
/**
 * Copyright (C) 2022, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSTiGaReelSwingOffPhase.ts
 * Date Author Changes
 * Mar 10, 2022 Shruti Agrawal Created
 *
 */
namespace Reels {
    /**
    * BSTiGaReelSwingOffPhase Custom class created.
    * @author <a href=mailto:SAgrawal@gauselmann.com>Shruti Agrawal</a>
    * @version $Revision: 1.0 $ $Date:  Mar 10, 2022 $
    */
    export class BSTiGaReelSwingOffPhase extends RTGReelSwingOffPhase {
        protected swingOffValues: number[];
        constructor(game: Phaser.Game, id: string, animationTrigger?: Array<ReelAnimationTrigger> | string) {
            super(game, id, animationTrigger);
                this.swingOffValues = [
                    0.7,
                    0.91,
                    0.84,
                    0.63,
                    0.40,
                    0.21,
                    0.07,
                    0.00
            ];
            this._lowestReelPositionIndex = this.getLowestReelPositionIndex();
        }
    }
}